import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import SimpleSlider from "./slider";
import "./expertise.css";

function Expertise() {
  return (

    <section className="main-team">
      <Container>
        <Row>
          <Col>
            <div className="team-title">
              <title> lithonia primary care doctor</title>
              <span className="sub-title">MEET OUR</span>
              <h2 className="h2-title">PROVIDERS</h2>
            </div>
          </Col>
        </Row>

        <div className="main-team-slider">
          <title> lithonia primary care doctor</title>
          <SimpleSlider />
        </div>
      </Container>
    </section>

  );
}

export default Expertise;
